import React from 'react';
import { APP_VERSION, BUILD_TIME } from '../constants';

export const VersionInfo = ({ context, isFrameReady }) => (
  <div className="version-info">
    <p>Version: {APP_VERSION}</p>
    <p>Build Time: {BUILD_TIME}</p>
    <p>Environment: {context ? 'Mini App' : 'Browser'}</p>
    <p>Ready: {isFrameReady ? 'Yes' : 'No'}</p>
  </div>
); 